import { render, staticRenderFns } from "./JigBlockquote.vue?vue&type=template&id=2c72d4f4"
import script from "./JigBlockquote.vue?vue&type=script&lang=ts"
export * from "./JigBlockquote.vue?vue&type=script&lang=ts"
import style0 from "./JigBlockquote.vue?vue&type=style&index=0&id=2c72d4f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports